import {
  GridToolbarContainer,
  useGridApiContext,
  useGridSelector,
  gridRowSelectionStateSelector,
} from '@mui/x-data-grid-premium';
import PropTypes from 'prop-types';
import { Button, Typography } from '@mui/material';

const CustomToolbar = ({ actionButtons = [] }) => {
  const apiRef = useGridApiContext();

  // Subscribed to changes in row selection: re-renders whenever the selection changes
  const selectedIds = useGridSelector(apiRef, gridRowSelectionStateSelector);
  const count = selectedIds.length;

  if (count === 0) return null;

  return (
    <GridToolbarContainer sx={{ bgcolor: 'action.selected', px: 2 }}>
      <Typography variant='body2' sx={{ flex: 1 }}>
        {count} selected
      </Typography>

      {actionButtons.map((button) => (
        <Button
          key={button.label}
          size='small'
          sx={{ mx: 1, bgcolor: 'background.paper', height: '24px' }}
          variant='outlined'
          onClick={() => button.onClickHandler(selectedIds)}
        >
          {button.label}
        </Button>
      ))}

      <Button size='small' onClick={() => apiRef.current.setRowSelectionModel([])}>
        Clear
      </Button>
    </GridToolbarContainer>
  );
};

CustomToolbar.propTypes = {
  actionButtons: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      onClickHandler: PropTypes.func.isRequired,
    })
  ),
};

export default CustomToolbar;